export default __webpack_public_path__ + "static/media/BookHeader.3e05e0c0.svg";